import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';


import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import * as d3 from 'd3';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-dashboard-report-escalation',
    templateUrl: './dashboard-report-escalation.component.html',
    styleUrls: ['./dashboard-report-escalation.component.css']
})
export class DashboardReportEscalationComponent implements OnInit {

    respObject: any;
    private clientId: number;
    gridOptions: GridOption;
    columnDefinitions: Column[];
    private notifier: NotifierService;
    angularGrid: AngularGridInstance;
    gridObj: any;
    sLAComplainceObj = [];
    reportTypeArray = [];
    reportFilterArray = [];
    ticketTypeArray = [];
    selectedReportType: number;
    selectedReportFilter: number;
    selectedTicketType: number;
    dateRangeView: boolean;
    tillDateView: boolean;
    fromDate: string;
    toDate: string;
    tillDate: string;
    reportTypeTitle: string;
    reportFilterTitle: string;
    viewTicketType: boolean;
    largegraph: boolean;

    dataLoaded: boolean;
    viewReport: boolean;

    //Report Data
    reportTableDat = [];
    reportTableRef = [];
    reportPieData = [];
    reportVolData = [];

    @ViewChild('barChart')
    private chartContainer: ElementRef;

    @ViewChild('barChartVolume')
    private barChartVolume: ElementRef;

    @ViewChild('pieChartVolume')
    private pieChartVolume: ElementRef;

    @ViewChild('reportBody')
    private reportBody: ElementRef;

    margin = {top: 20, right: 20, bottom: 30, left: 40};

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
    }

    ngOnInit() {
        // this.reportTypeArray = [{type:0, view:"Select Report Type"},
        //                         {type:1, view:"Overall"},
        //                         {type:2, view:"Support group"},
        //                         {type:3, view:"Category"},
        //                         {type:4, view:"Ticket type"},
        //                       ];

        // this.reportFilterArray = [{type:0, view:"Select Report Filter"},
        //                       {type:1, view:"Daily"},
        //                       {type:2, view:"Weekly"},
        //                       {type:3, view:"Monthly"},
        //                       {type:4, view:"Quarterly"},
        //                       {type:5, view:"Yearly"},
        //                       {type:6, view:"Till Date"},
        //                       {type:7, view:"From and to date"},
        //                     ];

        this.dateRangeView = false;
        this.tillDateView = false;
        this.viewTicketType = false;
        this.largegraph = true;
        this.dataLoaded = true;
        this.viewReport = false;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.selectedReportFilter = 0;
        this.selectedReportType = 0;
        this.selectedTicketType = 0;

        this.initSLAComplianceTableGrid();
        this.columnDefinitions = [];
        // this.getSLAComplianceTableReport();

        this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.clientId = this.respObject.details[0].clientId;
                //this.getSLAComplainceReport();
                this.getTicketType();
                this.getFilters();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getFilters() {
        this._rest.getReportFilters(this.clientId, 'ESCALATION').subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {

                this.reportTypeArray = this.respObject.details[0].type;
                this.reportFilterArray = this.respObject.details[0].filter;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getTicketType() {
        this._rest.getTicketType(this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ticketTypeArray = this.respObject.details;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    initSLAComplianceTableGrid() {
        this.gridOptions = {
            enableAutoResize: true,
            enableCellNavigation: true,
            enableFiltering: true,
            editable: false,
            autoHeight: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: false,
            enableRowSelection: true,
            enableHeaderMenu: true,
            enableGridMenu: false,
            headerRowHeight: 0,
        };
    }

    initSLAComplianceTable(tableDef) {
        const columnDefinitions = [];
        tableDef.forEach((column, i) => {
            columnDefinitions.push({id: column.field, name: column.name, field: column.field, sortable: false, filterable: false});
        });
        this.columnDefinitions = columnDefinitions;
    }

    onTicketTypeChange(value: any) {
        this.selectedReportFilter = 0;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;
    }

    onReportTypeChange(value: any) {
        this.selectedReportFilter = 0;
        this.selectedTicketType = 0;
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;

        if (this.selectedReportType === 3 || this.selectedReportType.toString() === '3') {
            this.viewTicketType = true;
            //this.largegraph = true;
            this.selectedTicketType = 0;
        } else if (this.selectedReportType === 2 || this.selectedReportType.toString() === '2') {
            this.viewTicketType = false;
            //this.largegraph = true;
        } else {
            this.viewTicketType = false;
            //this.largegraph = false;
        }
    }

    onReportFilterChange(value: any) {
        this.fromDate = '';
        this.toDate = '';
        this.tillDate = '';
        this.tillDateView = false;
        this.dateRangeView = false;

        if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            this.tillDateView = true;
            this.dateRangeView = false;
        } else if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {
            this.dateRangeView = true;
            this.tillDateView = false;
        } else {
            this.dateRangeView = false;
            this.tillDateView = false;
        }
    }

    generateSLAComplainceReport() {
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        const tilldate = this.messageService.ticketConverter(this.tillDate, 1);

        if (this.selectedReportType === 0) {
            this.notifier.notify('error', 'Please select a type');
            return;
        }

        if (this.selectedReportFilter === 0) {
            this.notifier.notify('error', 'Please select a filter');
            return;
        }

        if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            if (this.tillDate === '') {
                this.notifier.notify('error', 'Please select date');
                return;
            }
        }

        if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {

            if (this.fromDate === '') {
                this.notifier.notify('error', 'Please select from date');
                return;
            }

            if (this.toDate === '') {
                this.notifier.notify('error', 'Please select to date');
                return;
            }
        }

        if (this.selectedReportType === 3 && this.selectedTicketType === 0) {
            this.notifier.notify('error', 'Please select a ticket type');
            return;
        }

        this.dataLoaded = false;
        this.viewReport = false;
        this._rest.getEscalationReport(this.clientId, this.selectedReportType, this.selectedReportFilter, fdate, tdate, tilldate, this.selectedTicketType).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataLoaded = true;
                this.viewReport = true;
                this.reportTypeTitle = this.reportTypeArray[this.selectedReportType].view;
                this.reportFilterTitle = this.reportFilterArray[this.selectedReportFilter].view;


                if (this.selectedReportType === 3 || this.selectedReportType.toString() === '3') {
                    this.largegraph = true;
                } else if (this.selectedReportType === 2 || this.selectedReportType.toString() === '2') {
                    this.largegraph = true;
                } else {
                    this.largegraph = true;
                }
                this.initSLAComplianceTable(this.respObject.details[0].tableDef);
                this.sLAComplainceObj = this.respObject.details[0].tabledata;

                this.reportTableDat = this.respObject.details[0].tabledata;
                this.reportVolData = this.respObject.details[0].voldata;
                this.reportPieData = this.respObject.details[0].piedata;

                this.generateReportGraph();

            } else {
                this.dataLoaded = true;
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.dataLoaded = true;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    generateReportGraph() {
        this.createBarChart(this.reportTableDat);
        this.createGroupChart(this.reportVolData);
        this.createPieChart(this.reportPieData);
    }

    createBarChart(slaData) {
        const element = this.chartContainer.nativeElement;

        let dwidth = element.parentElement.parentElement.offsetWidth - 60;
        let dheight = 300;
        let marginBottom = 120;

        // if(this.largegraph){
        //   dwidth = 1000;
        //   dheight = 300;
        //   marginBottom = 120;
        // }
        // else{
        //   dwidth = 500;
        //   dheight = 200;
        //   marginBottom = 40;
        // }

        const data = slaData;
        d3.select(element).select('svg').remove();
        const margin = {top: 20, right: 20, bottom: marginBottom, left: 40},
            width = dwidth - margin.left - margin.right,
            height = dheight - margin.top - margin.bottom;

        let svg = d3.select(element).append('svg')
            .attr('width', dwidth)
            .attr('height', dheight);

        let x = d3
            .scaleBand()
            .rangeRound([0, width])
            .padding(0.1)
            .domain(data.map(d => d.type));

        let y = d3
            .scaleLinear()
            .rangeRound([height, 0])
            .domain([0, 100]);

        let colors = d3.scaleOrdinal(d3.schemeCategory10).domain(data.map(d => d.type));
        let g = svg.append('g')
            .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

        g.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x));

        if (this.largegraph) {
            g.selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '.15em')
                .attr('transform', 'rotate(-30)');
        }

        g.append('g')
            .attr('class', 'axis axis--y')
            .call(d3.axisLeft(y).tickFormat(function (d) {
                return parseInt(d, 10) + '%';
            }))
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '0.71em')
            .attr('text-anchor', 'end')
            .text('Escalation');

        g.selectAll('.bar')
            .data(data)
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('x', d => x(d.type))
            .attr('y', d => y(d.escalation))
            .attr('width', x.bandwidth())
            .attr('fill', function (d, i) {
                return colors(d.type);
            })
            .attr('height', d => height - y(d.escalation));

    }

    createGroupChart(groupData) {
        const element = this.barChartVolume.nativeElement;

        let dwidth = element.parentElement.parentElement.offsetWidth - 60;
        let dheight = 300;
        let marginBottom = 120;

        // if(this.largegraph){
        //   dwidth = 1000;
        //   dheight = 300;
        //   marginBottom = 120;
        // }
        // else{
        //   dwidth = 500;
        //   dheight = 200;
        //   marginBottom = 40;
        // }

        d3.select(element).select('svg').remove();
        const margin = {top: 20, right: 20, bottom: marginBottom, left: 40},
            width = dwidth - margin.left - margin.right,
            height = dheight - margin.top - margin.bottom;

        let x0 = d3.scaleBand().rangeRound([0, width], .5).paddingInner(0.1);
        ;
        let x1 = d3.scaleBand().padding(0.05);
        let y = d3.scaleLinear().rangeRound([height, 0]);

        let xAxis = d3.axisBottom().scale(x0).tickSize(0);
        let yAxis = d3.axisLeft().scale(y);

        const color = d3.scaleOrdinal(d3.schemeCategory10);

        let svg = d3.select(element).append('svg')
            .attr('width', dwidth)
            .attr('height', dheight)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        const categoriesNames = groupData.map(function (d) {
            return d.type;
        });
        const rateNames = groupData[0].volume.map(function (d) {
            return d.grpName;
        });

        x0.domain(categoriesNames);
        x1.domain(rateNames).rangeRound([0, x0.bandwidth()]);
        y.domain([0, d3.max(groupData, function (key) {
            return d3.max(key.volume, function (d) {
                return d.grpValue;
            });
        })]);

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

        if (this.largegraph) {
            svg.selectAll('text')
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '.15em')
                .attr('transform', 'rotate(-30)');
        }

        svg.append('g')
            .attr('class', 'y axis')
            .style('opacity', '0')
            .call(yAxis)
            .append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 6)
            .attr('dy', '.71em')
            .style('text-anchor', 'end')
            .style('font-weight', 'bold')
            .text('Value');

        svg.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

        const slice = svg.selectAll('.slice')
            .data(groupData)
            .enter().append('g')
            .attr('class', 'g')
            .attr('transform', function (d) {
                return 'translate(' + x0(d.type) + ',0)';
            });

        slice.selectAll('rect')
            .data(function (d) {
                return d.volume;
            })
            .enter().append('rect')
            .attr('width', x1.bandwidth() - 5)
            .attr('x', function (d) {
                return x1(d.grpName);
            })
            .style('fill', function (d) {
                return color(d.grpName);
            })
            .attr('y', function (d) {
                return y(0);
            })
            .attr('height', function (d) {
                return height - y(0);
            })
            .on('mouseover', function (d) {
                d3.select(this).style('fill', d3.rgb(color(d.grpName)).darker(2));
            })
            .on('mouseout', function (d) {
                d3.select(this).style('fill', color(d.grpName));
            });


        slice.selectAll('rect')
            .transition()
            .delay(function (d) {
                return Math.random() * 1000;
            })
            .duration(1000)
            .attr('y', function (d) {
                return y(d.grpValue);
            })
            .attr('height', function (d) {
                return height - y(d.grpValue);
            });

        let legend = svg.selectAll('.legend')
            .data(groupData[0].volume.map(function (d) {
                return d.grpName;
            }).reverse())
            .enter().append('g')
            .attr('class', 'legend')
            .style('opacity', '0');

        if (this.largegraph) {
            legend.attr('transform', (d, i) => `translate(${i * 150},${height + 100})`);
        } else {
            legend.attr('transform', (d, i) => `translate(${i * 150},${height + 15})`);
        }

        legend.append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', function (d) {
                return color(d);
            });

        legend.append('text')
            .attr('x', 120)
            .attr('y', 10)
            .attr('dy', '.35em')
            .style('text-anchor', 'end')
            .text(function (d) {
                return d;
            });

        legend.transition().duration(500).delay(function (d, i) {
            return 1300 + 100 * i;
        }).style('opacity', '1');
    }

    createPieChart(data) {
        const element = this.pieChartVolume.nativeElement;
        d3.select(element).select('svg').remove();
        d3.select(element).select('div').remove();

        let text = '';
        const width = 250;
        const height = 200;
        const thickness = 40;
        const duration = 750;
        const padding = 10;
        const opacity = .8;
        const opacityHover = 1;
        const otherOpacityOnHover = .8;
        const tooltipMargin = 13;
        const radius = Math.min(width - padding, height - padding) / 2;

        let tots = d3.sum(data, function (d) {
            return d.value;
        });

        data.forEach(function (d) {
            //d.percentage = d.value  / tots;
            d.percentage = Math.round((Number(d.value) / Number(tots)) * 100);
        });

        const dataNest = d3.nest()
            .key(function (d) {
                return d.name;
            })
            .entries(data);

        let color = d3.scaleOrdinal(d3.schemeCategory10);

        if (dataNest.length > 10) {
            color = d3.scaleOrdinal(d3.schemeCategory20);
        }

        let svg = d3.select(element)
            .append('svg')
            .attr('class', 'pie')
            .attr('width', width)
            .attr('height', height);

        let g = svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ',' + (height / 2) + ')');

        let arc = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        let pie = d3.pie()
            .value(function (d) {
                return d.value;
            })
            .sort(null);

        let path = g.selectAll('path')
            .data(pie(data))
            .enter()
            .append('g')
            .append('path')
            .attr('d', arc)
            .attr('fill', (d, i) => color(i))
            .style('opacity', opacity)
            .style('stroke', 'white');
        // .on("mouseover", function(d) {
        //     d3.selectAll('path')
        //       .style("opacity", otherOpacityOnHover);
        //     d3.select(this)
        //       .style("opacity", opacityHover);

        //     let g = d3.select("svg")
        //       .style("cursor", "pointer")
        //       .append("g")
        //       .attr("class", "tooltip")
        //       .style("opacity", 0);

        //     g.append("text")
        //       .attr("class", "name-text")
        //       .text(`${d.data.name} (${d.data.value})`)
        //       .attr('text-anchor', 'middle');

        //     let text = g.select("text");
        //     let bbox = text.node().getBBox();
        //     let padding = 2;
        //     g.insert("rect", "text")
        //       .attr("x", bbox.x - padding)
        //       .attr("y", bbox.y - padding)
        //       .attr("width", bbox.width + (padding*2))
        //       .attr("height", bbox.height + (padding*2))
        //       .style("fill", "white")
        //       .style("opacity", 0.75);
        //   })
        // .on("mousemove", function(d) {
        //       let mousePosition = d3.mouse(this);
        //       let x = mousePosition[0] + width/2;
        //       let y = mousePosition[1] + height/2 - tooltipMargin;

        //       let text = d3.select('.tooltip text');
        //       let bbox = text.node().getBBox();
        //       if(x - bbox.width/2 < 0) {
        //         x = bbox.width/2;
        //       }
        //       else if(width - x - bbox.width/2 < 0) {
        //         x = width - bbox.width/2;
        //       }
        //       if(y - bbox.height/2 < 0) {
        //         y = bbox.height + tooltipMargin * 2;
        //       }
        //       else if(height - y - bbox.height/2 < 0) {
        //         y = height - bbox.height/2;
        //       }

        //       d3.select('.tooltip')
        //         .style("opacity", 1)
        //         .attr('transform',`translate(${x}, ${y})`);
        //   })
        // .on("mouseout", function(d) {
        //     d3.select("svg")
        //       .style("cursor", "none")
        //       .select(".tooltip").remove();
        //   d3.selectAll('path')
        //       .style("opacity", opacity);
        //   })
        // .on("touchstart", function(d) {
        //     d3.select("svg")
        //       .style("cursor", "none");
        // })
        // .each(function(d, i) { this._current = i; });

        var arcGenerator = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        let textPer = g.selectAll('.pie')
            .data(pie(data))
            .enter()
            .append('g')
            .append('text')
            .text(function (d) {
                return d.data.percentage + '%';
            })
            .attr('transform', function (d) {
                return 'translate(' + arcGenerator.centroid(d) + ')';
            })
            .style('text-anchor', 'middle')
            .style('font-size', '12px')
            .style('fill', '#000000')
            .style('font-weight', '500');

        let legend = d3.select(element).append('div')
            .attr('class', 'legend')
            .style('margin-top', '30px');

        let keys = legend.selectAll('.key')
            .data(data)
            .enter().append('div')
            .attr('class', 'key')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('margin-right', '20px');

        keys.append('div')
            .attr('class', 'symbol')
            .style('height', '10px')
            .style('width', '10px')
            .style('margin', '5px 5px')
            .style('background-color', (d, i) => color(i));

        keys.append('div')
            .attr('class', 'name')
            .text(d => `${d.name} (${d.value})`);

        keys.exit().remove();
    }

    onResize(e) {
        this.generateReportGraph();
    }

    exportAsPDF() {
        this.dataLoaded = false;
        const elementReport = this.reportBody.nativeElement;
        let reportTitle = 'Escalation By User - ';
        let fileName = 'Escalation By User ' + this.reportTypeTitle + ' wise.pdf';
        if (this.selectedReportFilter === 6 || this.selectedReportFilter.toString() === '6') {
            const tilldate = this.messageService.ticketConverter(this.tillDate, 1);
            reportTitle = reportTitle + ' till ' + tilldate;
        } else if (this.selectedReportFilter === 7 || this.selectedReportFilter.toString() === '7') {
            const fdate = this.messageService.ticketConverter(this.fromDate, 1);
            const tdate = this.messageService.ticketConverter(this.toDate, 1);
            reportTitle = reportTitle + ' ' + fdate + ' to ' + tdate;
        } else {
            reportTitle = reportTitle + ' ' + this.reportFilterTitle;
        }

        html2canvas(elementReport, {
            scale: 2
          }).then(canvas => {
          const imgWidth = 208;
          const pageHeight = 295;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          const heightLeft = imgHeight;
          const contentDataURL = canvas.toDataURL('image/png')
          let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
          pdf.setFont("helvetica");
          pdf.setFontType("bold");
          pdf.setFontSize(9);
          pdf.text(reportTitle, 10, 10)
          pdf.addImage(contentDataURL, 'PNG', 0, 20, imgWidth, imgHeight-20)
          pdf.save(fileName); // Generated PDF
          this.dataLoaded = true;
        });
    }


}
